import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`helm repo add posthog https://posthog.github.io/charts-clickhouse/
helm repo update
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      